export const epochToDate = timestamp => {
  if (!timestamp) {
    return null;
  }
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString();
};

export default epochToDate;
